/**
 * Page Header Component - Reusable header for all internal pages
 * Provides consistent title and subtitle styling using theme tokens
 */

import React from 'react';
import Heading from './Heading';
import styles from './PageHeader.module.css';

const PageHeader = ({
  title,
  subtitle,
  actions,
  titleStyle = {},
  subtitleStyle = {},
  className = '',
  style = {}
}) => {
  return (
    <div
      className={`${styles.pageHeader} ${className}`}
      style={style}
    >
      <h1
        className={styles.title}
        style={titleStyle}
      >
        {title}
      </h1>
      {subtitle && (
        <p
          className={styles.subtitle}
          style={subtitleStyle}
        >
          {subtitle}
        </p>
      )}

      {actions && (
        <div className={styles.actions}>
          {actions}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
